// @flow
import * as React from 'react';
import { connect } from 'react-redux';

import Preloader from '../../Preloader';
import { isAuthenticated } from '../../../utils/auth';
import * as actions from '../../../modules/actions';
import * as selectors from '../../../modules/selectors';

import RedirectToRecover from '../RedirectToRecover';

type Props = {
	is_authenticated: boolean,
	fetchUser: Function,
	children: React.Node,
	has_user: boolean,
	user: {
		recovered: 0 | 1
	},
	location: {
		pathname: string
	}
}

class FetchUserIfAuthenicated extends React.Component<Props> {
	componentDidMount() {
		const { fetchUser, is_authenticated } = this.props;
		if (is_authenticated) {
			fetchUser();
		}
	}

	get is_recover_page() {
		const { location } = this.props;
		return location.pathname.indexOf('activate') !== -1;
	}

	get should_redirect_to_recover() {
		const { user } = this.props;
		return user && user.recovered === 0 && !this.is_recover_page;
	}

	render() {
		const { children, has_user, is_authenticated } = this.props;

		if (!is_authenticated) {
			return children;
		}

		if (this.should_redirect_to_recover) {
			return <RedirectToRecover />;
		}

		return is_authenticated && has_user ? children : <Preloader />;
	}
}

const mapStateToProps = state => ({
	is_authenticated: isAuthenticated(),
	has_user: selectors.hasUser(state),
	user: selectors.getUser(state),
	is_pending_user: selectors.isUserPending(state)
});

const mapDispatchToProps = {
	fetchUser: actions.fetchUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(FetchUserIfAuthenicated);


// WEBPACK FOOTER //
// ./src/components/utils/FetchUserIfAuthenicated/index.js